// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2FC3i","info":"UpdateTermsInfo_info__3K9pd"};